import type { EventPayload } from '@side/analytics';

export enum TrackNavigationEvent {
  ClickOpeningTheProfileDropdown,
  ClickClosingTheProfileDropdown,
  ClickNavigateToSideBarSection,
  ClickScrollToCoverSheetSubsection,
  ClickGenerateOfferButton,
  ClickOpenOfferDocsDialog,
  SidebarStatusUpdate,
  AIChatResult,
}

type EventTypeLabels = Record<TrackNavigationEvent, string>;

export const NavigationEventLabels: EventTypeLabels = {
  [TrackNavigationEvent.ClickOpeningTheProfileDropdown]: 'NAVBAR',
  [TrackNavigationEvent.ClickClosingTheProfileDropdown]: 'NAVBAR',
  [TrackNavigationEvent.ClickNavigateToSideBarSection]: 'SIDEBAR',
  [TrackNavigationEvent.ClickScrollToCoverSheetSubsection]: 'SIDEBAR',
  [TrackNavigationEvent.ClickGenerateOfferButton]: 'SIDEBAR',
  [TrackNavigationEvent.ClickOpenOfferDocsDialog]: 'SIDEBAR',
  [TrackNavigationEvent.SidebarStatusUpdate]: 'SIDEBAR',
  [TrackNavigationEvent.AIChatResult]: 'AI_CHAT_RESULT',
};

type EventTypePayloads = Record<TrackNavigationEvent, EventPayload>;

export const NavigationEventMap: EventTypePayloads = {
  [TrackNavigationEvent.ClickOpeningTheProfileDropdown]: {
    eventContainer: 'navbar',
    eventTarget: 'profile-dropdown-toggle',
    eventType: 'click',
    task: 'expand',
  },
  [TrackNavigationEvent.ClickClosingTheProfileDropdown]: {
    eventContainer: 'navbar',
    eventTarget: 'profile-dropdown-toggle',
    eventType: 'click',
    task: 'collapse',
  },
  [TrackNavigationEvent.ClickNavigateToSideBarSection]: {
    eventContainer: 'sidebar',
    eventTarget: '[section]_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackNavigationEvent.ClickScrollToCoverSheetSubsection]: {
    eventContainer: 'sidebar',
    eventTarget: '[section]_coversheet_subsection',
    eventType: 'click',
    task: 'scroll_to_section',
  },
  [TrackNavigationEvent.ClickGenerateOfferButton]: {
    eventContainer: 'sidebar',
    eventTarget: 'generate_offer_button',
    eventType: 'click',
    task: 'open_generate_offer_dialog',
  },
  [TrackNavigationEvent.ClickOpenOfferDocsDialog]: {
    eventContainer: 'sidebar',
    eventTarget: 'offer_docs_button',
    eventType: 'click',
    task: 'open_offer_docs_dialog',
  },
  [TrackNavigationEvent.SidebarStatusUpdate]: {
    eventContainer: 'transaction_status_dropdown',
    eventTarget: 'transaction_status',
    eventType: 'click',
    task: 'select',
  },
  [TrackNavigationEvent.AIChatResult]: {
    eventContainer: 'ai_chat_view',
    eventTarget: 'ai_chat_view',
    eventType: 'load',
    task: 'view',
  },
};
